import React, { Component } from 'react';
import './Persons.css';
import apiService from "../../../services/apiService";
import { Redirect } from 'react-router-dom';
import cleaner from 'deep-cleaner';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ReactToExcel from 'react-html-table-to-excel';
import { jssPreset, StylesProvider } from '@material-ui/core/styles';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import rtl from 'jss-rtl';
import { create } from 'jss';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const theme = createMuiTheme({
  direction: 'rtl'
});

class Persons extends Component {

  state = {
    navigateToUpdate: false, Searchbutton: true, End: false, AllRes: [], obj: null, arrayDisplay: '', skip: 0, valueHoliday: null, table: false, PersonID: '', Situation: true, FirstName: '', CustomerID: '', residence: "", res: undefined,
    mAgeKids: '', AdAgeKids: '', mYofBirth: '', adYofBirth: '', mNumOfChildren: '', adNumOfChildren: '',
    GetHolidaysList: [], oneHoliday: undefined, AllHolidays: '', LastName: '', adYofimmigrant: '', mYofimmigrant: '',
    MaritalStatus: '', Cities: [], City: null, Cell: '', Survivor: '', sector: '', SoupKitchen: '',
    Supported: '', allPersons: null, mDateOfUpdate: null, adDateOfUpdate: null, Population: '', arrayLength: '', Street: null, Streets: []
  }

  componentDidMount() {
    this.GetHolidaysData()
    document.body.addEventListener('keypress', this.UseSearchEnter);
    if (this.props.ShowSearch) {
      this.Search(this.props.Search)
      this.props.ShowOldSearch(false)
    }
  }
  componentWillUnmount() { document.body.removeEventListener('keypress', this.UseSearchEnter); }
  UseSearchBuotten = (Searchbutton) => {
    this.Search(this.SearchToServer())
    if (Searchbutton) { this.setState({ Searchbutton: false }) }
  }
  UseSearchEnter = e => {
    if (e.keyCode === 13) {
      this.Search(this.SearchToServer())
    }
  }
  ResToTable = (people, length) => {
    if (length === true) { this.setState({ arrayDisplay: people.length }) }
    return people.map((people, index) => {
      let FamelyNum = people.Famely ? people.Famely.length > 0 ? people.Famely.length + 1 : 1 : 1;
      let apartmentNum = '', housenom = '', כתובת = '';
      function fix(value) { if (value === null || value === undefined) { return '' } else { return value }; }
      if (people.ApartmentNum === null || people.ApartmentNum === undefined) { } else { apartmentNum = people.ApartmentNum }
      if (people.Housenom === null || people.Housenom === undefined) { } else { housenom = people.Housenom }
      if (apartmentNum === '' || housenom === '') { } else { כתובת = apartmentNum + '/' + housenom }
      return (
        <tr key={index}
          onMouseDown={() => {
            this.props.find(people, this.SearchToServer())
            this.setState({ navigateToUpdate: true });
          }}>
          <td>{index + 1}</td>
          <td>{people.PersonID}</td>
          <td>{people.CustomerID ?? '—'}</td>
          <td>{people.LastName}</td>
          <td>{people.FirstName}</td>
          <td>{this.getAgefromData(people.DateOfBirth)}</td>
          <td>{FamelyNum}</td>
          <td>{fix(people.Street) + '  ' + כתובת}</td>
          <td>{people.City}</td>
          <td>{people.Cell}</td>
          <td>{people.Population}</td>
          <td>{people.Income}</td>
          <td>{people.MaritalStatus}</td>
        </tr>
      )
    })
  }

  onScroll = () => {
    if (this.state.End === false) {
      if (document.getElementById("persons").scrollTop > document.getElementById("persons").scrollHeight - 800) {
        this.setState({ End: true })
        const config = { headers: { Authorization: `Bearer ${this.props.User.Token}` } };
        const url = `${'./FindWlimit/'}${this.state.skip}`;
        apiService.post(url,
          this.state.obj, config)
          .then(r => {
            let a = [...this.state.AllRes]
            let b = r.data
            this.setState({ res: this.ResToTable(a.concat(b), true), AllRes: a.concat(b), skip: this.state.skip + 50 });
            if (r.data.length < 50 || r.data.length === 0) {
              alert('אין עוד נתונים')
            }
            else {
              this.setState({ table: true, End: false })
            }
          })
          .catch()
      }
    }
  }
  // עובד  -אין צורך
  // ritTOfile = () => {
  //  axios.post('./createJson',
  //  this.state.AllRes)
  //  .then()
  //  .catch()
  // }
  Search = (obj) => {
    this.setState({ res: undefined, arrayLength: '', arrayDisplay: '', skip: 50, AllRes: [], End: false });
    const config = { headers: { Authorization: `Bearer ${this.props.User.Token}` } };
    const url = `${'./FindWlimit/'}${0}`;
    apiService.post(url,
      obj, config)
      // this.SearchToServer(), config)
      .then(r => {
        this.setState({ res: this.ResToTable(r.data, true), AllRes: r.data, arrayDisplay: r.data.length });
        if (r.data.length === 0) {
          this.setState({ table: false })
          alert('אין נתונים תואמים')
        }
        else { this.setState({ table: true }) }
      })
      .catch()
    apiService.post('./find/',
      obj, config)
      .then(r => {
        this.setState({ arrayLength: r.data.length, allPersons: this.ResToTable(r.data) });
      })
      .catch()
  }
  ClearSearchField = () => {
    // Situation: '',
    this.setState({
      oneHoliday: '', PersonID: '', residence: '', FirstName: '', CustomerID: '', mAgeKids: '', AdAgeKids: '', mYofBirth: '', mDateOfUpdate: null, adDateOfUpdate: null,
      adYofBirth: '', mNumOfChildren: '', adNumOfChildren: '', AllHolidays: '', Survivor: '', sector: '', Cell: '', LastName: '',
      SoupKitchen: '', valueHoliday: null, Street: null, Supported: '', Population: '', Cities: [], MaritalStatus: '', City: null, adYofimmigrant: '', mYofimmigrant: '', CustomerID: ''
    })
  }

  GetHolidaysData = () => {
    apiService.get('/Holiday')
      .then(res => {
        this.setState({ GetHolidaysList: res.data });
      })
      .catch()
  }
  getAgefromData = date => {
    if (date === null || date === undefined || date === '') { return '' }
    else {
      const birth = new Date(date);
      let dd = birth.getDate();
      let mm = birth.getMonth() + 1
      let yy = birth.getFullYear();
      function calculate_age(birth_day, birth_month, birth_year) {
        const today_date = new Date();
        const today_year = today_date.getFullYear();
        const today_month = today_date.getMonth();
        const today_day = today_date.getDate();
        let age = today_year - birth_year;
        if (today_month < birth_month - 1) {
          age--;
        }
        if (birth_month - 1 === today_month && today_day < birth_day) {
          age--;
        }
        return age;
      }
      let numAge = calculate_age(dd, mm, yy)
      return numAge
    }
  }
  DateFun = date => {
    if (date === null) { return undefined } else {
      if (date.toString() === 'Invalid Date' || date === null) { return undefined } else { return date }
    }
  }
  numFun = value => {
    let numValue = Number(value)
    if (numValue > 0) { return numValue } else { return '' }
  }

  SearchToServer = () => {
    let mYofBirth = new Date(`${this.state.mYofBirth}-01-01T00:00:00.000Z`)
    let adYofBirth = new Date(`${this.state.adYofBirth}-01-01T00:00:00.000Z`)
    let mYofimmigrant = new Date(`${this.state.mYofimmigrant}-01-01T00:00:00.000Z`)
    let adYofimmigrant = new Date(`${this.state.adYofimmigrant}-01-01T00:00:00.000Z`)
    let mAgeKids = new Date(this.CreateInvalidDate(this.state.mAgeKids))
    let AdAgeKids = new Date(this.CreateInvalidDate(this.state.AdAgeKids))
    let city = undefined
    if (this.state.City === null) { } else { city = this.state.City.שם_ישוב }
    let Street = undefined
    if (this.state.Street === null) { } else { Street = this.state.Street }
    // נתונים לחיפוש שרת
    let obj = {
      PersonID: this.numFun(this.state.PersonID),
      CustomerID: this.numFun(this.state.CustomerID),
      DateOfBirth: { $gte: this.checkboxDate(mYofBirth), $lte: this.checkboxDate(adYofBirth) },
      immigrant: { $gte: this.checkboxDate(mYofimmigrant), $lte: this.checkboxDate(adYofimmigrant) },
      Famely: { '$elemMatch': { 'DateOfBirth': { '$lte': this.checkboxDate(mAgeKids), '$gte': this.checkboxDate(AdAgeKids) } } },
      NumKids: { $gte: this.numFun(this.state.mNumOfChildren), $lte: this.numFun(this.state.adNumOfChildren) },
      FirstName: { $regex: this.state.FirstName },
      residence: this.state.residence,
      // {FirstName:{ $regex: 'מזל' } }
      Cell: this.state.Cell,
      LastName: { $regex: this.state.LastName },
      Population: this.state.Population,
      MaritalStatus: this.state.MaritalStatus,
      Situation: this.checkCheckbox(this.state.Situation),
      Survivor: this.checkCheckbox(this.state.Survivor),
      sector: this.checkCheckbox(this.state.sector),
      SoupKitchen: this.checkCheckbox(this.state.SoupKitchen),
      Supported: this.checkCheckbox(this.state.Supported),
      UpdateDate: { $gte: this.DateFun(this.state.mDateOfUpdate), $lte: this.DateFun(this.state.adDateOfUpdate) },
      City: city,
      Street: Street,
    }
    if (this.state.AllHolidays === true) {
      obj.Holidays = { Holidays: { "$exists": true, "$not": { "$size": 0 } } }
      obj.Holidays = obj.Holidays.Holidays
    } else {
      obj.Holidays = this.state.oneHoliday
      if (this.state.oneHoliday === undefined) { } else { obj.Holidays = obj.Holidays.Holidays }
    }
    cleaner(obj.residence)
    cleaner(obj.LastName)
    cleaner(obj.FirstName)
    cleaner(obj.CustomerID)
    cleaner(obj.UpdateDate)
    cleaner(obj.Famely.$elemMatch.DateOfBirth)
    cleaner(obj.Famely.$elemMatch)
    cleaner(obj.Famely)
    cleaner(obj.NumKids)
    cleaner(obj.DateOfBirth)
    cleaner(obj.immigrant)
    cleaner(obj);
    this.setState({ obj: obj })
    // console.log(obj);
    return obj;
  }

  CreateInvalidDate = num => {
    if (num === isNaN || num === undefined || num === '') { return undefined }
    else {
      let today = new Date();
      let dd = checkTime(today.getDate());
      let mm = checkTime(today.getMonth() + 1)
      let Year = today.getFullYear() - num
      function checkTime(i) { if (i < 10) { i = "0" + i; } return i; }
      let dateTime = Year + '/' + mm + '/' + dd
      return dateTime
    }
  }

  checkboxDate = value => { if (value.toString() === 'Invalid Date') { return undefined } else { return value } }
  checkCheckbox = value => { if (value !== true) { value = undefined } else { return true } }
  renderTableHeader() {
    let header = ['/', 'ת.ז', 'מספר חבר', 'שם משפחה', 'שם פרטי', 'גיל', 'מספר נפשות', 'כתובת', 'ישוב', 'טלפון', 'אוכלוסיה', 'הכנסה', 'מצב משפחתי']
    return header.map((head, index) => {
      return <th key={index}>{head}</th>
    })
  }

  SetStateTargetvalue = (state, e) => { this.setState({ [state]: e.target.value }) }
  SetStateTargetchecked = (state, e) => { this.setState({ [state]: e.target.checked }) }
  SetStatedate = (state, date) => { this.setState({ [state]: date }) }

  City = (e, value) => {
    if (value === null || value === '' || value === [] || value === undefined) { this.setState({ City: undefined }); }
    else { this.setState({ City: value.שם_ישוב }); }
  }
  styleButton = () => {
    if (this.state.Searchbutton === false) {
      this.setState({ Searchbutton: true })
    }
    else {
      this.setState({ Searchbutton: false })
    }
  }

  render() {
    if (this.state.navigateToUpdate) { return <Redirect to='./Update' /> }
    return (
      <div className='Persons'>
        <div id='Persons'>
          <div className='top'>
            {/* <button onMouseDown={()=>{this.SearchToServer()}}>SearchToServer</button> */}
            <Button className="BigS" variant="contained" style={{ marginRight: '10px' }} onMouseDown={() => { this.UseSearchBuotten(false) }}>
              <i style={{ color: 'blue' }} className="fas fa-search"></i></Button>
            <Button className="Little" variant="contained" style={{ marginRight: '10px' }} onMouseDown={() => { this.UseSearchBuotten(true) }} >
              <i style={{ color: 'blue' }} className="fas fa-search"></i></Button>
            <Button variant="contained" style={{ marginRight: '10px' }} onMouseDown={() => { this.ClearSearchField() }}><i style={{ color: 'red' }} className="fas fa-brush"></i></Button>
          </div>
          <div className='center'>
            <StylesProvider jss={jss}>
              <ThemeProvider theme={theme}>
                {/*  */}
                {this.state.Searchbutton &&
                  <div>
                    <div className='divgroup' >
                      <div className='marginchecked'>
                        <div className='checkedDiv'>
                          <div className="groupPersons">
                            <label className='labelCheckbox'>פעיל</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.Situation} onChange={e => { this.SetStateTargetchecked('Situation', e) }} required />
                          </div>
                          <div className="groupPersons">
                            <label className='labelCheckbox'>נתמך</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.Supported} onChange={e => { this.SetStateTargetchecked('Supported', e) }} required />
                          </div>
                          <div className="groupPersons" id={'checkboxinput'}>
                            <label className='labelCheckbox'>בית תמחוי</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.SoupKitchen} onChange={e => { this.SetStateTargetchecked('SoupKitchen', e) }} required />
                          </div>
                          <div className="groupPersons">
                            <label className='labelCheckbox'>מגזר הערבי</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.sector} onChange={e => { this.SetStateTargetchecked('sector', e) }} required />
                          </div>
                          <div className="groupPersons">
                            <label className='labelCheckbox'>ניצול</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.Survivor} onChange={e => { this.SetStateTargetchecked('Survivor', e) }} required />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className='DivSearch'>
                      <div className='divgroup' >
                        <div className='margin2' >
                          <div className="group" style={{ width: '120px' }}>
                            <input value={this.state.PersonID} onChange={e => { this.SetStateTargetvalue('PersonID', e) }} dir='rtl' type="number" required />
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label className='LABEL'>ת.ז:</label>
                          </div>
                          <div className="group" style={{ width: '120px' }}>
                            <input value={this.state.CustomerID} onChange={e => { this.SetStateTargetvalue('CustomerID', e) }} dir='rtl' type="number" required />
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label className='LABEL'>מספר חבר</label>
                          </div>
                          <div className="group" style={{ width: '100px' }}>
                            <input value={this.state.FirstName} onChange={e => { this.SetStateTargetvalue('FirstName', e) }} type="text" required />
                            <span className="highlight"></span>
                            <span className="bar"></span>
                            <label className='LABEL'>שם פרטי</label>
                          </div>
                          <FormControl className='MaritalStatus' style={{ width: "110px", marginLeft: '5px', marginRight: '5px', marginTop: '1px' }} ><InputLabel>מגורים</InputLabel>
                            <Select value={this.state.residence} onChange={e => { this.SetStateTargetvalue('residence', e) }}><MenuItem value=""><em>ריק</em></MenuItem>
                              <MenuItem value={'בעלות'}>{'בעלות'}</MenuItem><MenuItem value={'השכרה'}>{'השכרה'}</MenuItem>
                              <MenuItem value={'דמי מפתח'}>{'דמי מפתח'}</MenuItem><MenuItem value={'דיור מוגן/הוסטל'}>{'דיור מוגן/הוסטל'}</MenuItem><MenuItem value={'עמידר'}>{'עמידר'}</MenuItem></Select></FormControl>
                        </div>
                        <div className='margin1' style={{ paddingTop: '10px' }}>
                          <div className="group" style={{ width: "90px", textAlign: 'right' }}>
                            <input style={{ width: "90px" }} value={this.state.LastName} onChange={e => { this.SetStateTargetvalue('LastName', e) }} type="text" required />
                            <span className="highlight" style={{ width: "90px" }}></span>
                            <span className="bar" style={{ width: "90px" }}></span>
                            <label className='LABEL' style={{ width: "90px" }}>משפחה</label>
                          </div>
                          <FormControl id='MaritalStatus' style={{ width: "120px", marginLeft: '5px', marginRight: '5px', marginTop: '1px' }}><InputLabel>מצב משפחתי</InputLabel>
                            <Select value={this.state.MaritalStatus} onChange={e => { this.SetStateTargetvalue('MaritalStatus', e) }}><MenuItem value=""><em>אחר</em></MenuItem>
                              <MenuItem value={'נשוי'}>נשוי</MenuItem><MenuItem value={'רווק'}>רווק</MenuItem>
                              <MenuItem value={'גרוש'}>גרוש</MenuItem><MenuItem value={'אלמן'}>אלמן</MenuItem></Select></FormControl>
                          <div className="group" style={{}}>
                            <input style={{ width: "145px" }} value={this.state.Cell} onChange={e => { this.SetStateTargetvalue('Cell', e) }} dir='rtl' type="text" required />
                            <span style={{ width: "145px" }} className="highlight"></span>
                            <span style={{ width: "145px" }} className="bar"></span>
                            <label className='LABEL'>פלאפון</label>
                          </div>
                        </div>
                        <div className='margin2 Holidays MaritalStatus' style={{ paddingTop: '2px' }}>
                          <div id='AutocompleteCity' className="group" style={{}}>
                            <Autocomplete style={{ width: '155px' }}
                              className="Autocomplete"
                              value={this.state.City}
                              onChange={(e, value) => {
                                this.setState({ Streets: [], Street: null });
                                if (value === null || value === '' || value === []) {
                                  this.setState({ City: null, Streets: [], Street: null });
                                }
                                else {
                                  this.setState({ City: value, Streets: value.שם_רחוב });
                                }
                              }}
                              options={this.state.Cities}
                              getOptionLabel={option => option.שם_ישוב}
                              renderInput={params => <TextField
                                onChange={e => {
                                  if (e.target.value === '') { }
                                  else {
                                    apiService.post('/GetCities/', { שם_ישוב: { $regex: e.target.value } })
                                      .then(city => {
                                        this.setState({ Cities: city.data });
                                      })
                                      .catch()
                                  }
                                }}
                                {...params} label="עיר" />}
                            /> </div>
                          <div id='AutocompleteCity' className="group" style={{}}>
                            <Autocomplete style={{ width: '145px' }}
                              value={this.state.Street}
                              className="Autocomplete"
                              onChange={(e, value) => {
                                if (value === null || value === '' || value === []) {
                                  this.setState({ Street: null });
                                }
                                else {
                                  this.setState({ Street: value });
                                }
                              }
                              }
                              options={this.state.Streets}
                              getOptionLabel={option => option}
                              renderInput={params => <TextField
                                {...params} label="רחוב" />}
                            /> </div>
                        </div>
                      </div>
                      <div className='divgroup' >
                        <div className='margin2 Holidays' style={{ paddingTop: '2px' }}>
                          <FormControl style={{ width: "145px", marginLeft: '5px', marginRight: '5px', }}><InputLabel>אוכלסיה</InputLabel>
                            <Select value={this.state.Population} onChange={e => { this.SetStateTargetvalue('Population', e) }}><MenuItem value=""><em>ריק</em></MenuItem>
                              <MenuItem value='נזקקת'>נזקקת</MenuItem><MenuItem value='רווחה'>רווחה</MenuItem></Select></FormControl>
                          <div className="group" id={'checkboxinput'} style={{ paddingTop: '5px' }}>
                            <label className='labelCheckbox'>חגים</label>
                            <input style={{ width: '15px' }} type="checkbox" checked={this.state.AllHolidays} onChange={e => { this.SetStateTargetchecked('AllHolidays', e) }} />
                          </div>
                          <div id='AutocompleteCity' className="group">
                            <Autocomplete
                              className="Autocomplete"
                              value={this.state.valueHoliday}
                              onChange={(e, value) => {
                                if (value === null || value === '' || value === []) {
                                  this.setState({ oneHoliday: undefined });
                                }
                                else {
                                  let Name = value.Name, Y = value.Y
                                  this.setState({ valueHoliday: value, oneHoliday: { Holidays: { '$elemMatch': { Name, Y } } } })
                                }
                              }
                              }
                              options={this.state.GetHolidaysList}
                              getOptionLabel={option => option.Name + ' - ' + option.Y}
                              style={{ width: '130px' }}
                              renderInput={params => <TextField
                                {...params} label="חג ספציפי" />}
                            /> </div>
                        </div>
                        <div className='margin1 DateOfUpdate'>
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '17px' }}>תאריך עידכון:</span>
                          <div className="group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} ><KeyboardDatePicker labelstyle={{ right: '0' }} label="מתאריך"
                              format="dd/MM/yyyy" value={this.state.mDateOfUpdate} style={{ height: '42px', verticalAlign: 'sub', width: '135px', right: '0' }} onChange={(date) => { this.SetStatedate('mDateOfUpdate', date) }} /></MuiPickersUtilsProvider>
                          </div>
                          <div className="group" style={{}}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} ><KeyboardDatePicker labelstyle={{ right: '0' }} label="עד תאריך "
                              format="dd/MM/yyyy" value={this.state.adDateOfUpdate} style={{ height: '42px', verticalAlign: 'sub', width: '135px', right: '0' }} onChange={(date) => { this.SetStatedate('adDateOfUpdate', date) }} /></MuiPickersUtilsProvider>
                          </div>
                        </div>
                        {/* <div className='margin1' >
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '10px' }}> שנת לידה:</span>
                          <div className="group">
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.mYofBirth} onChange={e => { this.SetStateTargetvalue('mYofBirth', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>משנת</label>
                          </div>
                          <div className="group" style={{}}>
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.adYofBirth} onChange={e => { this.SetStateTargetvalue('adYofBirth', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>עד שנת</label>
                          </div>
                        </div> */}
                        <div className='margin2' >
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '10px' }}>שנת עליה:</span>
                          <div className="group">
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.mYofimmigrant} onChange={e => { this.SetStateTargetvalue('mYofimmigrant', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>משנת </label>
                          </div>
                          <div className="group" style={{}}>
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.adYofimmigrant} onChange={e => { this.SetStateTargetvalue('adYofimmigrant', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>עד שנת </label>
                          </div>
                        </div>
                      </div>
                      <div className='divgroup'>
                        <div className='margin1'>
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '10px' }}> גיל ילדים:</span>
                          <div className="group">
                            <input max="99" size='2' style={{ width: "135px" }} value={this.state.mAgeKids} onChange={e => { this.SetStateTargetvalue('mAgeKids', e) }} dir='rtl' type="number" required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>מגיל</label>
                          </div>
                          <div className="group" style={{}}>
                            <input max="99" size='2' style={{ width: "135px" }} value={this.state.AdAgeKids} onChange={e => { this.SetStateTargetvalue('AdAgeKids', e) }} dir='rtl' type="number" required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>עד גיל</label>
                          </div>
                        </div>
                        <div className='margin2'>
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '10px' }}>מספר ילדים:</span>
                          <div className="group">
                            <input max="99" size='2' style={{ width: "135px" }} value={this.state.mNumOfChildren} onChange={e => { this.SetStateTargetvalue('mNumOfChildren', e) }} dir='rtl' type="number" required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>ממספר</label>
                          </div>
                          <div className="group" style={{}}>
                            <input max="99" size='2' style={{ width: "135px" }} value={this.state.adNumOfChildren} onChange={e => { this.SetStateTargetvalue('adNumOfChildren', e) }} dir='rtl' type="number" required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>עד מספר</label>
                          </div>
                        </div>
                        <div className='margin1' >
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '10px' }}> שנת לידה:</span>
                          <div className="group">
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.mYofBirth} onChange={e => { this.SetStateTargetvalue('mYofBirth', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>משנת</label>
                          </div>
                          <div className="group" style={{}}>
                            <input maxLength="4" type="text" size='4' style={{ width: "135px" }} value={this.state.adYofBirth} onChange={e => { this.SetStateTargetvalue('adYofBirth', e) }} dir='rtl' required />
                            <span style={{ width: "135px" }} className="highlight"></span>
                            <span style={{ width: "135px" }} className="bar"></span>
                            <label className='LABEL'>עד שנת</label>
                          </div>
                        </div>
                        {/* <div className='margin1 DateOfUpdate'>
                          <span style={{ fontSize: '20px', textAlign: 'right', width: '110px', paddingTop: '17px' }}>תאריך עידכון:</span>
                          <div className="group">
                            <MuiPickersUtilsProvider utils={DateFnsUtils} ><KeyboardDatePicker labelstyle={{ right: '0' }} label="מתאריך"
                              format="dd/MM/yyyy" value={this.state.mDateOfUpdate} style={{ height: '42px', verticalAlign: 'sub', width: '135px', right: '0' }} onChange={(date) => { this.SetStatedate('mDateOfUpdate', date) }} /></MuiPickersUtilsProvider>
                          </div>
                          <div className="group" style={{}}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} ><KeyboardDatePicker labelstyle={{ right: '0' }} label="עד תאריך "
                              format="dd/MM/yyyy" value={this.state.adDateOfUpdate} style={{ height: '42px', verticalAlign: 'sub', width: '135px', right: '0' }} onChange={(date) => { this.SetStatedate('adDateOfUpdate', date) }} /></MuiPickersUtilsProvider>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>}
              </ThemeProvider>
            </StylesProvider>
            {this.state.table && <div id='table'>
              <Button style={{ marginRight: '5px', padding: '0 10px' }} size="small" variant="contained">מציג:{this.state.arrayLength + ' / ' + this.state.arrayDisplay}</Button>
              {this.state.allPersons && <ReactToExcel id='Excel'
                className='fas fa-file-export'
                table='allPersons'
                //  fileExtension="xlsx"
                filename='yadByadData'
                sheet='sheet 1'
                buttonText='' />}
              <button className='styleButton'
                onMouseDown={() => { this.styleButton(); }}>{this.state.Searchbutton ? "הסתר פרמטרים" : "הראה פרמטרים"}</button>

              <table id='persons' onScroll={this.onScroll}>
                <tbody>
                  <tr>{this.renderTableHeader()}</tr>
                  {this.state.res}
                </tbody>
              </table>
            </div>}
            <table id='allPersons' style={{ display: 'none' }}>
              <tbody>
                <tr>{this.renderTableHeader()}</tr>
                {this.state.allPersons}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}
export default Persons;